// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/9c8d17d1/" + chunkId + "." + __webpack_require__.h() + ".v9c8d17d1.js";
};